const NOTIFICATION_BASE_URL = '/Notifications';
export const NotificationPaths = {
    GetPage: `${NOTIFICATION_BASE_URL}?`,
    MarkAsRead: `${NOTIFICATION_BASE_URL}/MarkAsRead/{id}`,
    MarkAllAsRead: `${NOTIFICATION_BASE_URL}/MarkAllAsRead`,
}